import { axialHexDistance } from '../../coords';
import type { HexTileCoordinates } from '../../model/types';
import type { HexMapShape } from '../types';

const ORIGIN: HexTileCoordinates = { q: 0, r: 0 };

function createCircularHexMapShape(radius: number): HexMapShape {
  return {
    id: `circular:${radius}`,
    *getCoordinates(): Iterable<HexTileCoordinates> {
      for (let q = -radius; q <= radius; q++) {
        for (let r = -radius; r <= radius; r++) {
          const coordinates = { q, r };
          if (axialHexDistance(ORIGIN, coordinates) > radius) continue;
          yield coordinates;
        }
      }
    },
  };
}

export { createCircularHexMapShape };
